import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteHeaderProvider } from '@shapeable/ui';
// import { SiteHeaderLayout } from '../entities/site-header-layout';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      max-width: 500px;
    }
  `,
  tablet: css`
  `,
  desktop: css`
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  const { titleRich, subtitleRich } = entity;
  const hasTitles = !!titleRich.text || !!subtitleRich.text;

  return (
    <SiteHeaderProvider value={{ 
      variant: 'default',
     }}>
    <My.Layout 
      className={className}
      entity={entity}
      slices={slices}
      headerProps={{ aspectRatio: 
        { base: 4 / 3, desktop: 21 / 9 }, 
        showOverlayGradient: true, 
        fadeColor: '#0000000', 
        // backgroundColor: '#0000000',
        useBackgroundColor: true }} 
    />
    </SiteHeaderProvider>
  )
};
